<template>
  <viewer v-if="ready" v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </viewer>
</template>

<script>
import { loadViewer } from '@assets/utils/lazyViewer'

export default {
  name: 'LazyViewer',
  data () {
    return { ready: false }
  },
  mounted () {
    loadViewer().then(() => {
      this.ready = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public/LazyViewer.vue